import { render, staticRenderFns } from "./BadReceiptRegEndS0409.vue?vue&type=template&id=46513d68&"
import script from "./BadReceiptRegEndS0409.vue?vue&type=script&lang=js&"
export * from "./BadReceiptRegEndS0409.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports